import type { SortOrder } from './types';

export const sortMenuItemsConfig: {
  text: string;
  value: SortOrder;
}[] = [
  {
    text: 'Most Popular',
    value: '',
  },
  {
    text: 'Latest Launched',
    value: 'release_date,desc',
  },
  {
    text: 'Model (Ascending)',
    value: 'name,asc',
  },
  {
    text: 'Model (Descending)',
    value: 'name,desc',
  },
  {
    text: 'Price (Highest)',
    value: 'price,desc',
  },
  {
    text: 'Price (Lowest)',
    value: 'price,asc',
  },
  {
    text: 'User Ratings (Highest)',
    value: 'rating,desc',
  },
  {
    text: 'User Ratings (Lowest)',
    value: 'rating,asc',
  },
];
